import { TFormSchema, useStore } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import axios from "axios";
import { api } from "@/comn";

export const lpcoEnvs = {
    base: `${process.env.REACT_APP_BASE}`,
    comnAppPageList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/comn/app-list`, // Lpco Page List
    comnSelectComnCdList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/cd/`, // Common Code List
    comnSelectOrgList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/org/org-cd`, // Organization Code List
    comnSelectOrgAllList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/org/org-cd/all`, // Organization Code List
    comnSelectOrgLpco: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/app/org-app`, // Applicaton List
    comnSelectOrgInfoByTin: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/org/org-info`, // Org Information
    comnTreeOrgDept: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/comn/org-dept`, // Department Tree Data
    frontComnCdMPpup: `${process.env.REACT_APP_BASE}/lpco/comn/ppup/comn-cd-m`, // Common Code Popup
    frontOrgDeptPpup: `${process.env.REACT_APP_BASE}/lpco/comn/ppup/org-dept`, // Organization Department Popup
    frontUsrPpup: `${process.env.REACT_APP_BASE}/lpco/comn/ppup/usr`, // User Popup
    comnSelectComnCdWithCondList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/cd/cond`, // Common Code List With Condition
    comnSelectComnInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/cd/info`, // Common Info
    // comnSelectCpntList: `${process.env.REACT_APP_API_OSCI}/api/v1/eswe/comn/cpnt-list`, // Application Component List
    comnSelectCpntList: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/comn/app/cpnt-list`, // Application Component List

    comnRprtLpco: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt/lpco`,
    comnRprtHlthCrte: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt/lpco/hlth-crte`,
    comnRprtBll: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt/bll`,
    comnRprtRcpt: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt/rcpt`,
    comnUrlFileDownload: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/files/url/download`,

    ORG_CD_TRA: "OGAM0033",

    frontSpfcCdPpup: `${process.env.REACT_APP_BASE}/lpco/comn/ppup/spfc-cd`, // Additional Item Specific Code Popup
};
/*
 * 프로젝트별 공통기능(함수) 사용시 작성
 */
export const lpcoUtils = {
    /*
     * 샘플 함수
     */
    func: () => {
        console.log("call project common function");
    },

    /**
     * !==해당하는 폼에 값을 세팅한다.==!
     * Usage : lpcoUtils.setFormValues(location.state, form.{formName})
     * @param state
     * @param form
     */
    setFormValues: (state: any, form: any) => {
        if (!comnUtils.isEmptyObject(state)) {
            Object.entries(state).map(([key, value]) => {
                console.log("key : %s , value: %s", key, value);
                form.setValue(key, value);
                // console.log(form.getValue());
            });
        } else {
            console.log("has no parameter datas.");
        }
    },

    setObjectValues: (fromObj: any, toObj: any) => {
        if (!comnUtils.isEmpty(fromObj)) {
            Object.keys(fromObj).forEach((item: any) => {
                // console.log("setObjectValues items ::: %s", item);
                if (toObj.hasOwnProperty(item)) {
                    toObj[item] = fromObj[item];
                }
            });
        }
    },
    getComnAppPageList: async (data: any, page: number, size: number) => {
        return await api.get(`${lpcoEnvs.comnAppPageList}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getComnCdList: async (comnCd: string) => {
        try {
            const resp = await api.get(`${lpcoEnvs.comnSelectComnCdList}/${comnCd}`);
            return resp.data.comnCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgCdList: async () => {
        try {
            const resp = await api.get(`${lpcoEnvs.comnSelectOrgList}`);
            return resp.data.orgCdList?.content || [];
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgCdAllList: async () => {
        try {
            const resp = await api.get(`${lpcoEnvs.comnSelectOrgAllList}`);
            return resp.data.orgCdList?.content || [];
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgLpcoList: async (orgCd: string) => {
        const resp = await api.get(`${lpcoEnvs.comnSelectOrgLpco}/${orgCd}`);
        return resp.data.appList?.content || [];
    },
    getOrgLpcoByPrcsList: async (orgCd: string) => {
        const resp = await api.get(`${lpcoEnvs.comnSelectOrgLpco}/${orgCd}/by-prcs`);
        return resp.data.appList?.content || [];
    },
    getOrgInfoByTin: async (orgTin: string) => {
        const resp = await api.get(`${lpcoEnvs.comnSelectOrgInfoByTin}/${orgTin}`);
        return resp.data.info?.content || {};
    },
    setOrgInfoByTin: async (tin: any) => {
        const info = await lpcoUtils.getOrgInfoByTin(tin);
        lpcoUtils.orgInfo = { ...info };
        console.log(" lpcoUtils.orgInfo ", lpcoUtils.orgInfo);
        return info;
    },
    orgInfo: { orgCd: "", orgNm: "" },
    setSrchFormFromStore(srchForm: any, pgeStore: any) {
        srchForm?.setValues({ ...(pgeStore?.form || {}) });
    },
    getComnCdWithCondList: async (data: any) => {
        try {
            const resp = await api.get(`${lpcoEnvs.comnSelectComnCdWithCondList}`, {
                params: comnUtils.toGetParams(data),
            });
            return resp.data.comnCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getComnCdInfo: async (data: any) => {
        const resp = await api.get(`${lpcoEnvs.comnSelectComnInfo}`, {
            params: comnUtils.toGetParams(data),
        });
        return resp.data.comnCdIInfo?.content || {};
    },
    errorListSortByRow: (errList: any[]) => {
        const sortedList = errList
            .filter((item) => item.row !== undefined)
            .sort((a, b) => {
                return a.row! - b.row!;
            });
        const remainingItems = errList.filter((item) => item.row === undefined);
        return sortedList.concat(remainingItems);
    },
    getErrorObj: (row: any, label: string, message: string, input = "", type = "error") => {
        return {
            row: row,
            label: label,
            message: message,
            type: type,
            input: input,
        };
    },
    getErrorMessagesObj: (valdnItmNm: any, errMsgCn: string) => {
        return {
            valdnItmNm: valdnItmNm,
            msgCn: errMsgCn,
        };
    },

    getCodeLabel: async (arrData: any[], value: string) => {
        return arrData.filter((item: any) => item.cdVldVal == value)?.[0]?.cdVldValNm;
    },

    getOrgDeptTreeData: async (orgCd: string) => {
        const resp = await api.get(`${lpcoEnvs.comnTreeOrgDept}/${orgCd}`);
        return resp.data.orgDeptTreeData?.content || [];
    },
    saveExcelDownload: (downurl: any, params: any) => {
        api.post(downurl, params, { responseType: "blob" })
            .then((response): void => {
                const blob: Blob = new Blob([response.data], { type: response.headers["content-type"] });
                const contentDisposition = response.headers["content-disposition"];
                let fileName: string = "exceldown.xlsx";
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.split(";").filter(function (str: any) {
                        return str.includes("filename");
                    });
                    if (fileNameMatch && fileNameMatch.length > 0) {
                        const arrFileNameMatch = fileNameMatch[0].split("=");
                        if (arrFileNameMatch != null && arrFileNameMatch.length > 1) {
                            fileName = arrFileNameMatch[1];
                        }
                    }
                }
                fileName = decodeURI(fileName).replaceAll('"', "");
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    // IE10 +
                    (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
                } else {
                    // not ie
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", fileName);
                    link.style.cssText = "display:none";
                    link.target = "_self";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            })
            .catch((error) => {
                console.error("Error while downloading file:", error);
            });
    },
    // Search Application Componet !== 신청서 컴포넌트 목록 조회  ==!
    getCpntList: async (data: any) => {
        try {
            const resp = await api.get(`${lpcoEnvs.comnSelectCpntList}`, {
                params: data,
            });
            return resp.data.cpntCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },

    fileDownload: async (fileGrpUuid: any, fileUuid: any, fileNm: any, fileExt: any) => {
        const fileDownloadUrl = process.env.REACT_APP_API_OSCI + "/api/v1/ptle/comn/files/download";
        try {
            const response = await api.post(
                fileDownloadUrl,
                {
                    fileGrpUuid: fileGrpUuid,
                    fileUuid: fileUuid,
                },
                { responseType: "blob" },
            );
            const url = URL.createObjectURL(response.data);
            const a = document.createElement("a");
            const nm: string = fileNm || "";
            const ext: string = fileExt ? "." + fileExt : "";

            a.download = nm.endsWith(ext) ? nm : nm + ext;
            a.href = url;
            a.click();
            a.remove();
        } catch (error) {
            console.log(error);
        }
    },

    urlFileDownload: (fileUrlAddr: any) => {
        api.get(lpcoEnvs.comnUrlFileDownload, {
            params: { fileUrlAddr },
            responseType: "blob",
        })
            .then((response): void => {
                const blob: Blob = new Blob([response.data], { type: response.headers["content-type"] });
                const contentDisposition = response.headers["content-disposition"];

                // URL 끝값을 기본 파일명으로 사용 !== default file name from URL tail ==!
                let fileName: string = fileUrlAddr.substring(fileUrlAddr.lastIndexOf("/") + 1) || "download";

                if (contentDisposition) {
                    const parts = contentDisposition.split(";").map((str: string) => str.trim());

                    // RFC 5987 filename*=charset''value 우선, 없으면 일반 filename="value"
                    // !== prefer RFC 5987 filename*, fallback to plain filename ==!
                    const extended = parts.find((str: string) => str.toLowerCase().startsWith("filename*="));
                    const plain = parts.find((str: string) => str.toLowerCase().startsWith("filename="));

                    if (extended) {
                        // filename*=UTF-8''%ED%95%9C... → charset''lang 접두어 제거 후 디코드
                        let value = extended.substring(extended.indexOf("=") + 1);
                        const tickIdx = value.indexOf("''");
                        if (tickIdx > -1) {
                            value = value.substring(tickIdx + 2);
                        }
                        try {
                            fileName = decodeURIComponent(value);
                        } catch {
                            fileName = value;
                        }
                    } else if (plain) {
                        // filename= 뒤 전체 사용(값에 '='가 있어도 안전) + 양끝 따옴표 제거
                        let value = plain
                            .substring(plain.indexOf("=") + 1)
                            .trim()
                            .replace(/^"|"$/g, "");
                        try {
                            fileName = decodeURIComponent(value);
                        } catch {
                            fileName = value;
                        }
                    }
                }

                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", fileName);
                link.style.cssText = "display:none";
                link.target = "_self";
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(link.href); // blob URL 해제 !== free blob url ==!
                link.remove();
            })
            .catch((error) => {
                console.error("Error while downloading file:", error);
            });
    },

    getBillPrint: (bllNo: any) => {
        let url = `${lpcoEnvs.comnRprtBll}/${bllNo}`;
        return api.get(url, {
            responseType: "arraybuffer",
        });
    },
    getRcptPrint: (bllNo: any) => {
        let url = `${lpcoEnvs.comnRprtRcpt}/${bllNo}`;
        return api.get(url, {
            responseType: "arraybuffer",
        });
    },
    // Get LPCO Report !== LPCO 보고서 미리보기 조회 ==!
    getRprtLpco: (appId: any, allStatYn: any = "") => {
        let url = `${lpcoEnvs.comnRprtLpco}/${appId}`;
        if (allStatYn == "Y") {
            url = `${lpcoEnvs.comnRprtLpco}/all/${appId}`;
        }
        return api.get(url, {
            responseType: "arraybuffer",
        });
    },
    // Get Health Certificate Report !== 건강 증명서 보고서 미리보기 조회 ==!
    getRprtHlthCrte: (appId: any, allStatYn: any = "") => {
        let url = `${lpcoEnvs.comnRprtHlthCrte}/${appId}`;
        if (allStatYn == "Y") {
            url = `${lpcoEnvs.comnRprtHlthCrte}/all/${appId}`;
        }
        return api.get(url, {
            responseType: "arraybuffer",
        });
    },
    /**
     * Masking.
     * Input : 4-2
     * Output : [/[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, "-", /[A-Z0-9]/, /[A-Z0-9]/]
     * @param pattern
     * @returns
     */
    getMaskPattern: (pattern: string, separator: string) => {
        let arr: Array<any> = [];
        // prettier-ignore
        pattern.split(/-/).forEach((val) => {
        if (/\d/.test(val)) {
            for (let i = 0; i < Number(val); i++) {
                arr.push(/[a-zA-Z0-9]/);
            }
        } else {
            arr.push(val);
        }
        arr.push(separator);
    });
        arr.pop();
        return arr;
    },
    // !== FILE UPLOAD ==!
    uploadFile: async (uploadUrl: string, formData: FormData, responseCallback: any, errorCallback: any) => {
        await api
            .post(uploadUrl, formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then((response) => {
                if (responseCallback && typeof responseCallback === "function") responseCallback(response);
            })
            .catch((error) => {
                if (errorCallback && typeof errorCallback === "function") errorCallback(error);
            });
    },
};
